module.exports = __webpack_public_path__ + "static/media/Shopping-cart-icon.fb9d720b.svg";